<div class="recent-orders">
    <div class="title-buttons d-flex justify-content-between align-items-center">
        <strong>Testimonials</strong>
        <button (click)="addTestimonial()" class="button button-submit button-md"> Add Testimonial </button>
    </div>
    <br />
    <div class="table-responsive">
        <table class="table table-striped" id="testimonials-table">
            <thead>
                <tr class="first last">
                    <th>Photo</th>
                    <th>Name</th>
                    <th>Company</th>
                    <th>Location</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody *ngIf="loading">
                <tr>
                    <td colspan="5" style="text-align: center">Loading ...</td>
                </tr>
            </tbody>
            <tbody *ngIf="!loading && testimonials.length === 0">
                <tr>
                    <td colspan="5" style="text-align: center">No testimonials found</td>
                </tr>
            </tbody>
            <tbody *ngIf="!loading && testimonials.length > 0">
                <tr *ngFor="let testimonial of testimonials">
                    <td>
                        <img *ngIf="testimonial.profilePhotoPath" [src]="testimonial.profilePhotoPath" [alt]="testimonial.displayName" style="max-height: 60px; max-width: 100px; object-fit: contain; border-radius: 50%;" />
                        <span *ngIf="!testimonial.profilePhotoPath" class="text-muted">No photo</span>
                    </td>
                    <td>{{ testimonial.displayName }}</td>
                    <td>{{ testimonial.company }}</td>
                    <td>{{ testimonial.location }}</td>
                    <td>
                        <button class="btn btn-sm btn-outline-primary me-2" (click)="viewDetails(testimonial)">
                            View
                        </button>
                        <button class="btn btn-sm btn-outline-danger" (click)="confirmDelete(testimonial)">Delete</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<!-- View Details Modal -->
<ng-container *ngIf="showDetailsModal">
    <div class="modal show" style="display: block; z-index: 9999;" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header" style="background: #0c812c; color: #fff;">
                    <h5 class="modal-title">Testimonial Details</h5>
                    <button type="button" class="btn-close btn-close-white" (click)="closeDetails()"></button>
                </div>
                <div class="modal-body">
                    <div *ngIf="loadingDetails" class="py-4 text-center">
                        <p>Loading details...</p>
                    </div>
                    <div *ngIf="!loadingDetails && selectedTestimonial" class="text-center">
                        <img *ngIf="selectedTestimonial.profilePhotoPath" [src]="selectedTestimonial.profilePhotoPath" [alt]="selectedTestimonial.displayName" class="mb-3" style="max-height: 120px; max-width: 120px; object-fit: contain; border-radius: 50%;" />
                        <h4>{{ selectedTestimonial.displayName }}</h4>
                        <p class="text-muted">{{ selectedTestimonial.jobTitle }}</p>
                        <p class="text-muted">{{ selectedTestimonial.company }} | {{ selectedTestimonial.location }}</p>
                        <div class="testimonial-comment mt-3 p-3" style="background: #f8f9fa; border-radius: 8px; font-style: italic;">
                            "{{ selectedTestimonial.comment }}"
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="closeDetails()">Close</button>
                    <button type="button" class="btn btn-primary" (click)="editFromModal()">Edit</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show" style="z-index: 9998;"></div>
</ng-container>

<!-- Delete Confirmation Modal -->
<ng-container *ngIf="showDeleteModal">
    <div class="modal show" style="display: block; z-index: 9999;" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Confirm Delete</h5>
                    <button type="button" class="btn-close" (click)="cancelDelete()"></button>
                </div>
                <div class="modal-body">
                    Are you sure you want to delete the testimonial from <strong>{{ testimonialToDelete?.displayName }}</strong>?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="cancelDelete()">Cancel</button>
                    <button type="button" class="btn btn-danger" (click)="deleteTestimonial()">Delete</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show" style="z-index: 9998;"></div>
</ng-container>
